import { TableFilter } from '../../component-library/table/filtering/table-filter';

export class PaginationParameters {
  public skip: number;
  public take: number;
  public selectedItemId: string;
  public idsToExclude: string[];
  public searchText: string;
  public filters: TableFilter[];
  public sortField: string;
  public sortOrder: number;
  public principalId: string;
}
